import React from "react";
import { useNavigate } from "react-router-dom";

// Botón "← Volver" con el mismo formato que el de Supervisora → Compras.
// Vuelve a la pantalla anterior; si se entró directamente (sin pantalla anterior
// en la app), va a `fallback`.
export default function BotonVolver({ fallback = "/login", onClick, style }) {
  const navigate = useNavigate();
  const volver = () => {
    if (onClick) return onClick();
    const idx = window.history.state && window.history.state.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };
  return (
    <div style={{ textAlign: "left", marginBottom: 12, ...style }}>
      <button onClick={volver} style={{
        padding: "10px 22px", borderRadius: 20,
        background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
        color: "#fff", border: "none", cursor: "pointer",
        fontWeight: 700, fontSize: 15,
        boxShadow: "0 2px 8px rgba(29,78,216,0.35)",
      }}>← Volver</button>
    </div>
  );
}
